import {ComparisonSpecificationType} from "../../definitions/types";
import {ProductAttributeTypeValueDisplayType} from "../../definitions/enums";

export class ComparisonTableSpecificationModel {
    private readonly _typeId: number;
    private readonly _typeName: string;
    private readonly _unit?: string;
    private readonly _valueDisplayMode: ProductAttributeTypeValueDisplayType;

    constructor(comparisonSpecificationType: ComparisonSpecificationType) {
        this._typeId = comparisonSpecificationType.typeId;
        this._typeName = comparisonSpecificationType.typeName;
        this._unit = comparisonSpecificationType.unit;
        this._valueDisplayMode = comparisonSpecificationType.valueDisplayMode ?? ProductAttributeTypeValueDisplayType.Default;
    }

    /**
     * @property typeId
     * @description The unique identifier of the specification type.
     * @returns {number}
     */
    public get typeId(): number {
        return this._typeId;
    }

    /**
     * @property typeName
     * @description The name of the specification type.
     * @returns {string}
     */
    public get typeName(): string {
        return this._typeName;
    }

    /**
     * @property unit
     * @description The unit of the specification type.
     * @returns {string | undefined}
     */
    public get unit(): string | undefined {
        return this._unit;
    }

    /**
     * @property valueDisplayMode
     * @description The value display mode of the specification type.
     * @returns {ProductAttributeTypeValueDisplayType}
     */
    public get valueDisplayMode(): ProductAttributeTypeValueDisplayType {
        return this._valueDisplayMode;
    }
}